module.exports = __webpack_public_path__ + "img/topleft.2a796f09.png";